export default class AntipoisonDogUnit {
    constructor(antipoisonDogUsed, antipoisonDogId) {
        this.antipoisonDogUsed = antipoisonDogUsed;
        this.antipoisonDogId = antipoisonDogId;
    }
}